import { creatorsReportEndpointIds } from 'root/src/shared/creatorsReport/creatorsReport.constants';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const sqsCreateCreatorsReportEndpoint = {
    [creatorsReportEndpointIds.SQS_CREATE_CREATORS_REPORT]: {
        endpointType: otherEndpointType,
    },
};
